import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  iconButton: {
    marginRight: 10,
  },
  progressContainer: {
    height: 6
  }
}));
